import LogoSlider from "../HomePage/LogoSlider";
import OpportunitiesBanner from "./OpportunitiesBanner";
import OpportunitiesTab from "./OpportunitiesTab";

function OpportunitiesPage() {
  return (
    <>
        <OpportunitiesBanner/>
        <OpportunitiesTab/>
     
        
    </>
  )
}

export default OpportunitiesPage;